import { render, staticRenderFns } from "./LockerDeliveriesTable.vue?vue&type=template&id=a9b24fd2"
import script from "./LockerDeliveriesTable.vue?vue&type=script&lang=js"
export * from "./LockerDeliveriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports